export default "__VITE_ASSET__84d5a116__"